module.exports = __webpack_public_path__ + "static/media/mangesh.42597e8a.png";